"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createInstance = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createInstance = function createInstance() {
  var defaultProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _React$createContext = _react.default.createContext(),
      Consumer = _React$createContext.Consumer,
      Provider = _React$createContext.Provider;

  function isFunction(children) {
    return typeof children === 'function';
  }

  function renderChildren(children, data) {
    return isFunction(children) ? children(data) : children;
  }

  function consumerFactory(condition) {
    return function (_ref) {
      var children = _ref.children;
      return _react.default.createElement(Consumer, null, function (state) {
        return condition(state) && renderChildren(children, condition(state));
      });
    };
  }

  var Async =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Async, _PureComponent);

    function Async() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Async);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Async)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_timeoutIdentifier", null);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        params: {},
        loadingStatus: Async.LOADING_STATUS.PENDING,
        response: undefined,
        error: undefined
      });

      return _this;
    }

    _createClass(Async, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!isFunction(this.props.action)) {
          throw new Error('"action" props must be a function');
        }

        if (!this.props.onDemand) {
          this._handleAction();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!_lodash.default.isEqual(prevProps.params, this.props.params)) {
          this._handleAction();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            children = _this$props.children,
            onDemand = _this$props.onDemand;
        return _react.default.createElement(Provider, {
          value: this.state
        }, renderChildren(children, _objectSpread({}, this.state, {
          isPending: this.state.loadingStatus === Async.LOADING_STATUS.PENDING,
          isLoading: this.state.loadingStatus === Async.LOADING_STATUS.LOADING,
          cancel: function cancel() {
            return _this2._cancel();
          },
          run: function run() {
            return onDemand && _this2._handleAction();
          },
          reload: function reload() {
            return _this2._handleAction();
          }
        })));
      }
    }, {
      key: "_handleAction",
      value: function _handleAction() {
        var _this3 = this;

        var _this$props2 = this.props,
            action = _this$props2.action,
            transformer = _this$props2.transformer,
            onResolve = _this$props2.onResolve,
            onReject = _this$props2.onReject,
            delay = _this$props2.delay,
            rest = _objectWithoutProperties(_this$props2, ["action", "transformer", "onResolve", "onReject", "delay"]);

        var request = Promise.resolve();

        if (this.state.loadingStatus === Async.LOADING_STATUS.LOADING) {
          return;
        }

        clearTimeout(this._timeoutIdentifier);
        this.setState({
          loadingStatus: Async.LOADING_STATUS.LOADING,
          response: undefined,
          error: undefined
        });

        if (delay) {
          request = this._timeout(delay);
        }

        request.then(this._cancelResolver(function () {
          return action(rest);
        })).then(this._cancelResolver(function (response) {
          onResolve(response);

          _this3.setState({
            response: transformer(response || null),
            loadingStatus: Async.LOADING_STATUS.LOADED
          });
        })).catch(this._cancelResolver(function (error) {
          onReject(error);

          _this3.setState({
            error: error || null,
            loadingStatus: Async.LOADING_STATUS.LOADED
          });
        }));
      }
    }, {
      key: "_cancel",
      value: function _cancel() {
        if (this.state.loadingStatus !== Async.LOADING_STATUS.LOADING) {
          console.warn('Nothing to cancel...');
          return;
        }

        this.setState({
          loadingStatus: Async.LOADING_STATUS.CANCELLED
        });
      }
    }, {
      key: "_timeout",
      value: function _timeout(ms) {
        var _this4 = this;

        return new Promise(function (resolve) {
          _this4._timeoutIdentifier = setTimeout(_this4._cancelResolver(resolve), ms);
        });
      }
    }, {
      key: "_cancelResolver",
      value: function _cancelResolver(fn) {
        var _this5 = this;

        return function (data) {
          return _this5.state.loadingStatus === Async.LOADING_STATUS.CANCELLED || fn(data);
        };
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, state) {
        return _objectSpread({}, state, {
          params: props.params
        });
      }
    }]);

    return Async;
  }(_react.PureComponent);

  _defineProperty(Async, "propTypes", {
    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func]).isRequired,
    action: _propTypes.default.func.isRequired,
    transformer: _propTypes.default.func,
    onResolve: _propTypes.default.func,
    onReject: _propTypes.default.func,
    delay: _propTypes.default.number,
    onDemand: _propTypes.default.bool,
    params: _propTypes.default.object
  });

  _defineProperty(Async, "defaultProps", _objectSpread({
    transformer: function transformer(response) {
      return response;
    },
    onResolve: function onResolve(response) {},
    onReject: function onReject(error) {},
    onDemand: false,
    params: {}
  }, defaultProps));

  _defineProperty(Async, "LOADING_STATUS", {
    PENDING: 'pending',
    LOADING: 'loading',
    LOADED: 'loaded',
    CANCELLED: 'cancelled'
  });

  _defineProperty(Async, "Pending", consumerFactory(function (state) {
    return state.loadingStatus === Async.LOADING_STATUS.PENDING;
  }));

  _defineProperty(Async, "Loading", consumerFactory(function (state) {
    return state.loadingStatus === Async.LOADING_STATUS.LOADING;
  }));

  _defineProperty(Async, "Resolved", consumerFactory(function (state) {
    return state.loadingStatus === Async.LOADING_STATUS.LOADED && !state.error && state.response !== undefined && {
      response: state.response
    };
  }));

  _defineProperty(Async, "Rejected", consumerFactory(function (state) {
    return state.loadingStatus === Async.LOADING_STATUS.LOADED && !state.response && state.error !== undefined && {
      error: state.error
    };
  }));

  return Async;
};

exports.createInstance = createInstance;

var _default = createInstance();

exports.default = _default;